import React, { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/styles.scss";

import Header from "./components/Header";
import Slider from "./components/Slider";
import ScrollToTop from "./components/ScrollToTop";
import { getFirestore, getWithExpiry, setWithExpiry } from "./config/firebase";
import { AppProvider } from "./config/ToSendProvider";
import { WhatsAppConsultaProvider } from "./config/WhatsAppConsultaContext";

const Main = lazy(() => import("./components/Main"));
const Footer = lazy(() => import("./components/Footer"));
const WhatsAppFlotante = lazy(() => import("./components/WhatsAppFlotante/WhatsAppFlotante"));
const PromoModal = lazy(() => import("./components/PromoModal"));
const Error404 = lazy(() => import("./components/404"));

function App() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarVehiculos = async () => {
      const datosLocales = getWithExpiry("vehicles");
      if (datosLocales) {
        setVehicles(datosLocales);
        setLoading(false);
      } else {
        const db = getFirestore();
        const vehicles = db.collection("ford");
        try {
          const querySnapshot = await vehicles.get();
          const vehiclesData = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          setWithExpiry("vehicles", vehiclesData);
          setVehicles(vehiclesData);
          setLoading(false);
        } catch (error) {
          if (error?.code !== "cancelled" && error?.message !== "cancelled") {
            console.log(error);
          }
          setLoading(false);
        }
      }
    };

    cargarVehiculos();
  }, []);

  return (
    <AppProvider>
      <Router basename="/ford">
        <WhatsAppConsultaProvider>
          <ScrollToTop />
          <Switch>
            <Route exact path="/:tipo?">
              <Header vehicles={vehicles} loading={loading} />
              <Slider />
              <Suspense fallback={null}>
                <PromoModal />
                <Main vehicles={vehicles} loading={loading} />
                <Footer />
                <WhatsAppFlotante />
              </Suspense>
            </Route>

            <Route path="*">
              <Suspense fallback={null}>
                <Error404 />
              </Suspense>
            </Route>
          </Switch>
        </WhatsAppConsultaProvider>
      </Router>
    </AppProvider>
  );
}

export default App;
